import { AccountTreeOutlined, BarChart, EmojiEventsOutlined, Leaderboard, Timeline } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const ReferralSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.exchange.referral" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/referral/reward">
          <List.ItemIcon>
            <EmojiEventsOutlined />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.referral.reward.title" />
          </List.ItemText>
        </List.ItemButton>
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/referral/tree">
          <List.ItemIcon>
            <AccountTreeOutlined />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.referral.tree.title" />
          </List.ItemText>
        </List.ItemButton>
        {isProd ? null : (
          <List.ItemButton<typeof RouterLink> component={RouterLink} to="/referral/report/search">
            <List.ItemIcon>
              <BarChart />
            </List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id="pages.referral.report.title" />
            </List.ItemText>
          </List.ItemButton>
        )}
        {isProd ? null : (
          <List.ItemButton<typeof RouterLink> component={RouterLink} to="/referral/report/chart">
            <List.ItemIcon>
              <Timeline />
            </List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id="pages.referral.chart.title" />
            </List.ItemText>
          </List.ItemButton>
        )}
        {isProd ? null : (
          <List.ItemButton<typeof RouterLink> component={RouterLink} to="/referral/leaderboard">
            <List.ItemIcon>
              <Leaderboard />
            </List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id="pages.referral.leaderboard.title" />
            </List.ItemText>
          </List.ItemButton>
        )}
      </List>
    </StyledPaper>
  );
};
